export function cn(...inputs: (string | false | null | undefined | Record<string, boolean>)[]): string {
  return inputs
    .filter((item): item is string | Record<string, boolean> => item !== null && item !== undefined && item !== false)
    .map((item) => {
      if (typeof item === 'string') return item
      return Object.entries(item)
        .filter(([, active]) => active)
        .map(([className]) => className)
        .join(' ')
    })
    .filter(Boolean)
    .join(' ')
}
